<template>
  <div :class="['restricted-field-container', {'checkbox-container': position === 'checkbox'}]">
    <slot></slot>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <div
          :class="['restricted-indicator', indicatorClass]"
          :style="indicatorStyle"
          v-bind="attrs"
          v-on="on"
          aria-label="Staff Only field"
          role="img"
        ></div>
      </template>
      <span>{{ tooltip_text }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'RestrictedField',
  props: {
    tooltip_text: {
      type: String,
      default: 'Staff Only'
    },
    position: {
      type: String,
      default: 'top-right',
      //Checkboxes/switches make sense to be tighter to the input
      validator: value => ['top-right', 'checkbox'].includes(value)
    },
    offsetX: {
      type: Number,
      default: 0
    },
    offsetY: {
      type: Number,
      default: 0
    }
  },
  computed: {
    indicatorClass() {
      return `position-${this.position}`;
    },
    indicatorStyle() {
      if (this.offsetX === 0 && this.offsetY === 0) {
        return {};
      }
      return {
        transform: `translate(${this.offsetX}px, ${this.offsetY}px)`
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.restricted-field-container {
  position: relative;
  width: 100%;
}

.checkbox-container {
  display: flex;
  align-items: center;
}

.restricted-indicator {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #e53935;
  cursor: help;
  z-index: 5;
}

.position-top-right {
  top: 12px;
  right: 12px;
}

.position-top-left {
  top: 12px;
  left: 12px;
}

.position-label {
  top: -4px;
  left: -4px;
}

.position-checkbox {
  position: static !important; /* Override absolute positioning */
  display: inline-block;
  margin-left: 4px;
  margin-top: 0;
  vertical-align: middle;
}


</style>
